<template>
  <div class="shareQr">
    <div class="content-box">
      <div v-if="showApplet" class="book-title" @click="showBook">
        <div class="book-book" :class="{ showBook: showImage }">{{lan?"Get Tickets":"预订门票"}}</div>
        <div class="qr-code" v-if="showImage">
          <img
            class="xiaochengxu"
            :src="showQrCode || require('@/assets/xiaocxhenxu.png')"
            alt=""
          />
          <div class="showPublic-dec">{{lan?"Scan the QR code via WeChat for more information":"扫描二维码可预订门票"}}</div>
        </div>
      </div>
      <div v-if="showHomeStay" class="book-title" @click="showBook">
        <div class="book-book" :class="{ showBook: showImage }">{{lan?"Book Stay":"预订民宿"}}</div>
        <div class="qr-code" v-if="showImage">
          <img
            class="xiaochengxu"
            :src="showQrCode || require('@/assets/xiaocxhenxu.png')"
            alt=""
          />
          <div class="showPublic-dec">{{lan?"Scan the QR code to book a stay":"扫描二维码可预订民宿"}}</div>
        </div>
      </div>
      <div v-if="showExhibitionInfo" class="book-title" @click="showBook">
        <div class="book-book" :class="{ showBook: showImage }">
          {{lan?"Read More":"查看详情"}}
        </div>

        <div class="qr-code" v-if="showImage">
          <img
            class="xiaochengxu"
            :src="showQrCode || require('@/assets/xiaocxhenxu.png')"
            alt=""
          />
          <div class="showPublic-dec">{{lan?"Scan the QR code for more information":"扫描二维码可了解详情"}}</div>
        </div>
      </div>
      <div
        v-if="showPublic"
        :class="{
          showApp: !showApplet && !showHomeStay && !showExhibitionInfo,
        }"
        class="book-title-b"
        @click="showMore"
      >
        <div class="more-book" :class="{ showMore: isShowMore }">{{lan?"Explore More":"了解更多"}}</div>
        <div class="qr-code" v-if="isShowMore">
          <img class="xiaochengxu" src="@/assets/gonzhonghao.png" alt="" />
          <div class="showPublic-dec">{{lan?"Scan the QR code for more information":"关注公众号了解更多春阳台资讯"}}</div>
        </div>
      </div>
      <div
        v-if="showLodg"
        :class="{
          showApp: !showApplet && !showHomeStay && !showExhibitionInfo,
        }"
        class="book-title-b"
        @click="showMore"
      >
        <div class="more-book" :class="{ showMore: isShowMore }">{{lan?"Explore More":"了解更多"}}</div>
        <div class="qr-code" v-if="isShowMore">
          <img class="xiaochengxu" src="@/assets/gonzhonghao.png" alt="" />
          <div class="showPublic-dec">{{lan?"Scan the QR code for more information":"关注公众号了解民宿资讯"}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showApplet: {
      type: Boolean,
      default: true,
    },
    showHomeStay: {
      type: Boolean,
      default: true,
    },
    showExhibitionInfo: {
      type: Boolean,
      default: true,
    },
    showPublic: {
      type: Boolean,
      default: true,
    },
    showLodg: {
      type: Boolean,
      default: true,
    },
    showQrCode: {
      type: String,
      default: null,
    },
    showQrType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      showImage: false,
      isShowMore: false,
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  methods: {
    showBook() {
      this.showImage = !this.showImage;
    },
    showMore() {
      this.isShowMore = !this.isShowMore;
    },
  },
};
</script>

<style scoped>
.book-title {
  position: relative;
  width: 222px;
  min-height: 70px;
  border-top: 1px solid #585c64;
  border-bottom: 1px solid #585c64;
  cursor: pointer;
  background-color: #fff;
}
.book-title-b {
  position: relative;
  width: 222px;
  min-height: 70px;
  line-height: 70px;
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #2c2c2c;
  letter-spacing: 0;
  text-align: left;
  font-weight: Regular;
  border-bottom: 1px solid #585c64;
  background-color: #fff;
  cursor: pointer;
}
.book-book {
  width: 222px;
  line-height: 70px;
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #2c2c2c;
  letter-spacing: 0;
  text-align: left;
  font-weight: Regular;
}
.more-book {
  width: 222px;
  line-height: 70px;
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #2c2c2c;
  letter-spacing: 0;
  text-align: left;
  font-weight: Regular;
}
.book-book::after {
  content: "";
  position: absolute;
  top: 48%;
  right: 2px;
  width: 8px;
  height: 8px;
  border-top: 2px solid #666666;
  border-right: 2px solid #666666;
  -webkit-transform: translateY(-45%) rotate(135deg);
  transform: translateY(-45%) rotate(135deg);
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #666666;
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: #666666;
}
.more-book::after {
  content: "";
  position: absolute;
  top: 48%;
  right: 2px;
  width: 8px;
  height: 8px;
  border-top: 2px solid #666666;
  border-right: 2px solid #666666;
  -webkit-transform: translateY(-45%) rotate(135deg);
  transform: translateY(-45%) rotate(135deg);
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #666666;
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: #666666;
}
.qr-code {
  width: 222px;
  text-align: center;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #98989f;
  letter-spacing: 0;
  font-weight: Regular;
  margin-bottom: 28px;
}
.xiaochengxu {
  margin: 0 auto 9px;
  width: 190px;
  height: 190px;
}
.showBook::after {
  content: "";
  position: absolute;
  top: 11%;
  right: 2px;
  width: 8px;
  height: 8px;
  border-top: 2px solid #666666;
  border-right: 2px solid #666666;
  -webkit-transform: translateY(-45%) rotate(315deg);
  transform: translateY(-45%) rotate(315deg);
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #666666;
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: #666666;
}
.showMore::after {
  content: "";
  position: absolute;
  top: 11%;
  right: 2px;
  width: 8px;
  height: 8px;
  border-top: 2px solid #666666;
  border-right: 2px solid #666666;
  -webkit-transform: translateY(-45%) rotate(315deg);
  transform: translateY(-45%) rotate(315deg);
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #666666;
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: #666666;
}
.showApp {
  border-top: 1px solid #585c64;
}
.showPublic-dec {
  height: auto;
  font-size: 14px;
  line-height: 24px;
}
@media (max-width: 1440px) {
  .book-title {
    position: relative;
    width: 182px;
    min-height: 70px;
    border-top: 1px solid #585c64;
    border-bottom: 1px solid #585c64;
    cursor: pointer;
    background-color: #fff;
  }
  .book-title-b {
    position: relative;
    width: 182px;
    min-height: 70px;
    line-height: 70px;
    font-family: SourceHanSansCN-Regular;
    font-size: 18px;
    color: #2c2c2c;
    letter-spacing: 0;
    text-align: left;
    font-weight: Regular;
    border-bottom: 1px solid #585c64;
    background-color: #fff;
    cursor: pointer;
  }
  .qr-code {
  width: 182px;
  text-align: center;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #98989f;
  letter-spacing: 0;
  font-weight: Regular;
  margin-bottom: 28px;
}
  .book-book {
    width: 182px;
    line-height: 70px;
    font-family: SourceHanSansCN-Regular;
    font-size: 18px;
    color: #2c2c2c;
    letter-spacing: 0;
    text-align: left;
    font-weight: Regular;
  }
  .more-book {
    width: 182px;
    line-height: 70px;
    font-family: SourceHanSansCN-Regular;
    font-size: 18px;
    color: #2c2c2c;
    letter-spacing: 0;
    text-align: left;
    font-weight: Regular;
  }
  .xiaochengxu {
  margin: 0 auto 9px;
  width: 160px;
  height: 160px;
}
}
</style>